import { VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { calculatePercentageWidth, currentAccountWidthCols } from '../../../constants';

import { SkeletonProps } from '.';

interface DesktopProps extends Partial<SkeletonProps> {}

export const Desktop: React.FC<DesktopProps> = ({ viewportType }) => {
  const items = Object.keys(currentAccountWidthCols);

  const skeleton = items.map((item) => {
    const value = currentAccountWidthCols[item][viewportType];

    return (
      <VStack
        key={item}
        width={`${calculatePercentageWidth(value)}%`}
        space={Spacing['inline.nano']}>
        <Skeleton
          display={{ base: 'unset', lg: 'none' }}
          w="70%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="70%"
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
    );
  });

  return skeleton;
};
